<template>
  <section class="section cta">
    <div class="section-container reveal">
      <div class="cta-box">
        <div>
          <span class="section-label cta-label">Mari Bangun</span>
          <h2>Bangun masa depan bersama Abercode</h2>
          <p>
            Bersama kami, ide Anda dapat berkembang menjadi produk digital yang
            relevan, stabil, dan siap digunakan dalam skala nyata.
          </p>
        </div>
        <a href="#contactdetails" class="btn btn-accent">Mulai Sekarang</a>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "CTASection",
};
</script>

<style scoped>
.cta {
  padding-top: 28px;
}

.cta-box {
  border-radius: var(--radius-l);
  padding: clamp(24px, 4vw, 46px);
  background:
    linear-gradient(135deg, rgba(255, 99, 99, 0.92), rgba(13, 77, 164, 0.92)),
    #0d4da4;
  color: #fff;
  box-shadow: 0 20px 44px rgba(11, 48, 108, 0.3);
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
}

.cta-label {
  background: rgba(255, 255, 255, 0.14);
  border-color: rgba(255, 255, 255, 0.38);
  color: #fff;
}

.cta-box h2 {
  margin-top: 10px;
  font-size: clamp(1.6rem, 3.2vw, 2.6rem);
  line-height: 1.2;
}

.cta-box p {
  margin-top: 10px;
  max-width: 680px;
  color: rgba(255, 255, 255, 0.92);
}

.cta-box .btn {
  flex-shrink: 0;
  background: #fff;
  color: #1c2b4a;
}

.cta-box .btn:hover {
  box-shadow: 0 14px 30px rgba(14, 31, 59, 0.2);
}

@media (max-width: 760px) {
  .cta-box {
    flex-direction: column;
    align-items: flex-start;
  }

  .cta-box .btn {
    width: 100%;
  }
}
</style>
